import type { Connection, CardPositions, PendingConnection } from './types'
import { CARD_WIDTH, CARD_HEIGHT } from './types'

interface ConnectionLayerProps {
  connections: Connection[]
  cardPositions: CardPositions
  pendingConnection: PendingConnection | null
  canvasWidth: number
  canvasHeight: number
}

function getPath(
  sourceX: number, sourceY: number,
  targetX: number, targetY: number,
): string {
  const cpOffset = Math.min(80, Math.abs(targetX - sourceX) * 0.4)
  return `M ${sourceX} ${sourceY} C ${sourceX + cpOffset} ${sourceY}, ${targetX - cpOffset} ${targetY}, ${targetX} ${targetY}`
}

export default function ConnectionLayer({
  connections,
  cardPositions,
  pendingConnection,
  canvasWidth,
  canvasHeight,
}: ConnectionLayerProps) {
  return (
    <svg
      className="absolute inset-0 pointer-events-none"
      width={canvasWidth}
      height={canvasHeight}
      style={{ overflow: 'visible' }}
    >
      <defs>
        <marker
          id="arrowhead"
          markerWidth="10"
          markerHeight="7"
          refX="9"
          refY="3.5"
          orient="auto"
        >
          <polygon points="0 0, 10 3.5, 0 7" fill="#9ca3af" />
        </marker>
      </defs>

      {/* Committed connections */}
      {connections.map((conn) => {
        const source = cardPositions[conn.sourceDocId]
        const target = cardPositions[conn.targetDocId]
        if (!source || !target) return null

        const sx = source.x + CARD_WIDTH
        const sy = source.y + CARD_HEIGHT / 2
        const tx = target.x
        const ty = target.y + CARD_HEIGHT / 2

        return (
          <path
            key={conn.id}
            d={getPath(sx, sy, tx, ty)}
            fill="none"
            stroke="#9ca3af"
            strokeWidth={2}
            markerEnd="url(#arrowhead)"
          />
        )
      })}

      {/* Pending connection (dashed line to cursor) */}
      {pendingConnection && cardPositions[pendingConnection.sourceId] && (
        <path
          d={getPath(
            cardPositions[pendingConnection.sourceId].x + CARD_WIDTH,
            cardPositions[pendingConnection.sourceId].y + CARD_HEIGHT / 2,
            pendingConnection.mousePos.x,
            pendingConnection.mousePos.y,
          )}
          fill="none"
          stroke="#9ca3af"
          strokeWidth={2}
          strokeDasharray="6 4"
          markerEnd="url(#arrowhead)"
        />
      )}
    </svg>
  )
}
